export const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
  >
    <rect
      x="7.4541"
      y="9.5752"
      width="3"
      height="24"
      rx="1.5"
      transform="rotate(-45 7.4541 9.5752)"
      fill="white"
    />
    <rect
      x="7.4541"
      y="24.4248"
      width="24"
      height="3"
      rx="1.5"
      transform="rotate(-45 7.4541 24.4248)"
      fill="white"
    />
  </svg>
)

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2503 2C9.89485 2.00012 8.55912 2.32436 7.35451 2.94569C6.1499 3.56702 5.11135 4.46742 4.32549 5.57175C3.53963 6.67609 3.02926 7.95235 2.83696 9.29404C2.64466 10.6357 2.776 12.004 3.22003 13.2846C3.66406 14.5652 4.4079 15.7211 5.38949 16.6557C6.37108 17.5904 7.56196 18.2768 8.86277 18.6576C10.1636 19.0384 11.5366 19.1026 12.8673 18.8449C14.198 18.5872 15.4477 18.015 16.5123 17.176L20.1643 20.828C20.3529 21.0102 20.6055 21.1109 20.8677 21.1087C21.1299 21.1064 21.3807 21.0012 21.5661 20.8158C21.7515 20.6304 21.8566 20.3796 21.8589 20.1174C21.8612 19.8552 21.7604 19.6026 21.5783 19.414L17.9263 15.762C18.9142 14.5086 19.5294 13.0024 19.7014 11.4157C19.8733 9.82905 19.5951 8.22602 18.8985 6.79009C18.2019 5.35417 17.1151 4.14336 15.7626 3.29623C14.41 2.44911 12.8462 1.99989 11.2503 2ZM4.75025 10.5C4.75025 8.77609 5.43507 7.12279 6.65406 5.90381C7.87305 4.68482 9.52635 4 11.2503 4C12.9742 4 14.6275 4.68482 15.8464 5.90381C17.0654 7.12279 17.7503 8.77609 17.7503 10.5C17.7503 12.2239 17.0654 13.8772 15.8464 15.0962C14.6275 16.3152 12.9742 17 11.2503 17C9.52635 17 7.87305 16.3152 6.65406 15.0962C5.43507 13.8772 4.75025 12.2239 4.75025 10.5Z"
      fill="#05050C"
    />
  </svg>
)

export const MyListIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M5.25 14L11.25 14"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M15.25 17L21.25 17"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M18.2549 14.0049L18.2549 17.0049L18.2549 20.0049"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5.25 9L19.25 9"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5.25 4L19.25 4"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)

export const BarcodeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M6.1499 4.20234C5.83164 4.20234 5.52642 4.32877 5.30137 4.55382C5.07633 4.77886 4.9499 5.08408 4.9499 5.40234V8.10234C4.9499 8.34104 4.85508 8.56996 4.6863 8.73874C4.51752 8.90752 4.2886 9.00234 4.0499 9.00234C3.81121 9.00234 3.58229 8.90752 3.41351 8.73874C3.24472 8.56996 3.1499 8.34104 3.1499 8.10234V5.40234C3.1499 4.60669 3.46597 3.84363 4.02858 3.28102C4.59119 2.71841 5.35425 2.40234 6.1499 2.40234H8.8499C9.0886 2.40234 9.31752 2.49716 9.4863 2.66595C9.65508 2.83473 9.7499 3.06365 9.7499 3.30234C9.7499 3.54104 9.65508 3.76996 9.4863 3.93874C9.31752 4.10752 9.0886 4.20234 8.8499 4.20234H6.1499ZM6.1499 19.8023C5.83164 19.8023 5.52642 19.6759 5.30137 19.4509C5.07633 19.2258 4.9499 18.9206 4.9499 18.6023V15.9023C4.9499 15.6636 4.85508 15.4347 4.6863 15.2659C4.51752 15.0972 4.2886 15.0023 4.0499 15.0023C3.81121 15.0023 3.58229 15.0972 3.41351 15.2659C3.24472 15.4347 3.1499 15.6636 3.1499 15.9023V18.6023C3.1499 19.398 3.46597 20.1611 4.02858 20.7237C4.59119 21.2863 5.35425 21.6023 6.1499 21.6023H8.8499C9.0886 21.6023 9.31752 21.5075 9.4863 21.3387C9.65508 21.17 9.7499 20.941 9.7499 20.7023C9.7499 20.4636 9.65508 20.2347 9.4863 20.0659C9.31752 19.8972 9.0886 19.8023 8.8499 19.8023H6.1499ZM20.5499 5.40234C20.5499 5.08408 20.4235 4.77886 20.1984 4.55382C19.9734 4.32877 19.6682 4.20234 19.3499 4.20234H16.6499C16.4112 4.20234 16.1823 4.10752 16.0135 3.93874C15.8447 3.76996 15.7499 3.54104 15.7499 3.30234C15.7499 3.06365 15.8447 2.83473 16.0135 2.66595C16.1823 2.49716 16.4112 2.40234 16.6499 2.40234H19.3499C20.1455 2.40234 20.9086 2.71841 21.4712 3.28102C22.0338 3.84363 22.3499 4.60669 22.3499 5.40234V8.10234C22.3499 8.34104 22.2551 8.56996 22.0863 8.73874C21.9175 8.90752 21.6886 9.00234 21.4499 9.00234C21.2112 9.00234 20.9823 8.90752 20.8135 8.73874C20.6447 8.56996 20.5499 8.34104 20.5499 8.10234V5.40234ZM19.3499 19.8023C19.6682 19.8023 19.9734 19.6759 20.1984 19.4509C20.4235 19.2258 20.5499 18.9206 20.5499 18.6023V15.9023C20.5499 15.6636 20.6447 15.4347 20.8135 15.2659C20.9823 15.0972 21.2112 15.0023 21.4499 15.0023C21.6886 15.0023 21.9175 15.0972 22.0863 15.2659C22.2551 15.4347 22.3499 15.6636 22.3499 15.9023V18.6023C22.3499 19.398 22.0338 20.1611 21.4712 20.7237C20.9086 21.2863 20.1455 21.6023 19.3499 21.6023H16.6499C16.4112 21.6023 16.1823 21.5075 16.0135 21.3387C15.8447 21.17 15.7499 20.941 15.7499 20.7023C15.7499 20.4636 15.8447 20.2347 16.0135 20.0659C16.1823 19.8972 16.4112 19.8023 16.6499 19.8023H19.3499Z"
      fill="#05050C"
    />
    <path
      d="M18.4989 15.0303C18.3382 15.171 18.1202 15.25 17.8929 15.25C17.6655 15.25 17.4475 15.171 17.2868 15.0303C17.126 14.8897 17.0357 14.6989 17.0357 14.5V8.74827C17.0357 8.54936 17.126 8.35859 17.2868 8.21794C17.4475 8.07729 17.6655 7.99827 17.8929 7.99827C18.1202 7.99827 18.3382 8.07729 18.4989 8.21794C18.6597 8.35859 18.75 8.54936 18.75 8.74827V14.5C18.75 14.6989 18.6597 14.8897 18.4989 15.0303Z"
      fill="#05050C"
    />
    <path
      d="M15.0704 13.0282C15.2311 12.8875 15.3214 12.6968 15.3214 12.4978V8.74827C15.3214 8.54936 15.2311 8.35859 15.0704 8.21794C14.9096 8.07729 14.6916 7.99827 14.4643 7.99827C14.237 7.99827 14.0189 8.07729 13.8582 8.21794C13.6974 8.35859 13.6071 8.54936 13.6071 8.74827V12.4978C13.6071 12.6968 13.6974 12.8875 13.8582 13.0282C14.0189 13.1688 14.237 13.2478 14.4643 13.2478C14.6916 13.2478 14.9096 13.1688 15.0704 13.0282Z"
      fill="#05050C"
    />
    <path
      d="M11.6418 14.5282C11.4811 14.6688 11.263 14.7478 11.0357 14.7478C10.8084 14.7478 10.5904 14.6688 10.4296 14.5282C10.2689 14.3875 10.1786 14.1968 10.1786 13.9978V8.74827C10.1786 8.54936 10.2689 8.35859 10.4296 8.21794C10.5904 8.07729 10.8084 7.99827 11.0357 7.99827C11.263 7.99827 11.4811 8.07729 11.6418 8.21794C11.8026 8.35859 11.8929 8.54936 11.8929 8.74827V13.9978C11.8929 14.1968 11.8026 14.3875 11.6418 14.5282Z"
      fill="#05050C"
    />
    <path
      d="M8.21323 13.7786C8.37398 13.6379 8.46429 13.4472 8.46429 13.2483V8.74827C8.46429 8.54936 8.37398 8.35859 8.21323 8.21794C8.05249 8.07729 7.83447 7.99827 7.60714 7.99827C7.37981 7.99827 7.1618 8.07729 7.00105 8.21794C6.84031 8.35859 6.75 8.54936 6.75 8.74827V13.2483C6.75 13.4472 6.84031 13.6379 7.00105 13.7786C7.1618 13.9193 7.37981 13.9983 7.60714 13.9983C7.83447 13.9983 8.05249 13.9193 8.21323 13.7786Z"
      fill="#05050C"
    />
  </svg>
)

export const AIScanIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M5.6499 4.20234C5.33164 4.20234 5.02642 4.32877 4.80137 4.55382C4.57633 4.77886 4.4499 5.08408 4.4499 5.40234V8.10234C4.4499 8.34104 4.35508 8.56996 4.1863 8.73874C4.01752 8.90752 3.7886 9.00234 3.5499 9.00234C3.31121 9.00234 3.08229 8.90752 2.91351 8.73874C2.74472 8.56996 2.6499 8.34104 2.6499 8.10234V5.40234C2.6499 4.60669 2.96597 3.84363 3.52858 3.28102C4.09119 2.71841 4.85425 2.40234 5.6499 2.40234H8.3499C8.5886 2.40234 8.81752 2.49716 8.9863 2.66595C9.15508 2.83473 9.2499 3.06365 9.2499 3.30234C9.2499 3.54104 9.15508 3.76996 8.9863 3.93874C8.81752 4.10752 8.5886 4.20234 8.3499 4.20234H5.6499ZM5.6499 19.8023C5.33164 19.8023 5.02642 19.6759 4.80137 19.4509C4.57633 19.2258 4.4499 18.9206 4.4499 18.6023V15.9023C4.4499 15.6636 4.35508 15.4347 4.1863 15.2659C4.01752 15.0972 3.7886 15.0023 3.5499 15.0023C3.31121 15.0023 3.08229 15.0972 2.91351 15.2659C2.74472 15.4347 2.6499 15.6636 2.6499 15.9023V18.6023C2.6499 19.398 2.96597 20.1611 3.52858 20.7237C4.09119 21.2863 4.85425 21.6023 5.6499 21.6023H8.3499C8.5886 21.6023 8.81752 21.5075 8.9863 21.3387C9.15508 21.17 9.2499 20.941 9.2499 20.7023C9.2499 20.4636 9.15508 20.2347 8.9863 20.0659C8.81752 19.8972 8.5886 19.8023 8.3499 19.8023H5.6499ZM20.0499 5.40234C20.0499 5.08408 19.9235 4.77886 19.6984 4.55382C19.4734 4.32877 19.1682 4.20234 18.8499 4.20234H16.1499C15.9112 4.20234 15.6823 4.10752 15.5135 3.93874C15.3447 3.76996 15.2499 3.54104 15.2499 3.30234C15.2499 3.06365 15.3447 2.83473 15.5135 2.66595C15.6823 2.49716 15.9112 2.40234 16.1499 2.40234H18.8499C19.6455 2.40234 20.4086 2.71841 20.9712 3.28102C21.5338 3.84363 21.8499 4.60669 21.8499 5.40234V8.10234C21.8499 8.34104 21.7551 8.56996 21.5863 8.73874C21.4175 8.90752 21.1886 9.00234 20.9499 9.00234C20.7112 9.00234 20.4823 8.90752 20.3135 8.73874C20.1447 8.56996 20.0499 8.34104 20.0499 8.10234V5.40234ZM18.8499 19.8023C19.1682 19.8023 19.4734 19.6759 19.6984 19.4509C19.9235 19.2258 20.0499 18.9206 20.0499 18.6023V15.9023C20.0499 15.6636 20.1447 15.4347 20.3135 15.2659C20.4823 15.0972 20.7112 15.0023 20.9499 15.0023C21.1886 15.0023 21.4175 15.0972 21.5863 15.2659C21.7551 15.4347 21.8499 15.6636 21.8499 15.9023V18.6023C21.8499 19.398 21.5338 20.1611 20.9712 20.7237C20.4086 21.2863 19.6455 21.6023 18.8499 21.6023H16.1499C15.9112 21.6023 15.6823 21.5075 15.5135 21.3387C15.3447 21.17 15.2499 20.941 15.2499 20.7023C15.2499 20.4636 15.3447 20.2347 15.5135 20.0659C15.6823 19.8972 15.9112 19.8023 16.1499 19.8023H18.8499Z"
      fill="#05050C"
    />
    <path
      d="M10.1133 7.82626L10.4761 8.83383C10.8791 9.9521 11.7597 10.8327 12.878 11.2357L13.8856 11.5985C13.9764 11.6315 13.9764 11.7603 13.8856 11.7928L12.878 12.1556C11.7597 12.5587 10.8791 13.4393 10.4761 14.5575L10.1133 15.5651C10.0803 15.6559 9.95154 15.6559 9.91901 15.5651L9.55619 14.5575C9.15316 13.4393 8.27256 12.5587 7.15429 12.1556L6.14673 11.7928C6.05591 11.7598 6.05591 11.6311 6.14673 11.5985L7.15429 11.2357C8.27256 10.8327 9.15316 9.9521 9.55619 8.83383L9.91901 7.82626C9.95154 7.735 10.0803 7.735 10.1133 7.82626Z"
      fill="#05050C"
    />
    <path
      d="M14.6479 5.406L14.8318 5.91611C15.036 6.48224 15.4819 6.92819 16.0481 7.13242L16.5582 7.31631C16.6043 7.33303 16.6043 7.39809 16.5582 7.41481L16.0481 7.5987C15.4819 7.80292 15.036 8.24887 14.8318 8.81501L14.6479 9.32512C14.6311 9.37121 14.5661 9.37121 14.5494 9.32512L14.3655 8.81501C14.1613 8.24887 13.7153 7.80292 13.1492 7.5987L12.6391 7.41481C12.593 7.39809 12.593 7.33303 12.6391 7.31631L13.1492 7.13242C13.7153 6.92819 14.1613 6.48224 14.3655 5.91611L14.5494 5.406C14.5661 5.35946 14.6316 5.35946 14.6479 5.406Z"
      fill="#05050C"
    />
    <path
      d="M14.6479 14.0697L14.8318 14.5798C15.036 15.146 15.4819 15.5919 16.0481 15.7961L16.5582 15.98C16.6043 15.9968 16.6043 16.0618 16.5582 16.0785L16.0481 16.2624C15.4819 16.4666 15.036 16.9126 14.8318 17.4787L14.6479 17.9888C14.6311 18.0349 14.5661 18.0349 14.5494 17.9888L14.3655 17.4787C14.1613 16.9126 13.7153 16.4666 13.1492 16.2624L12.6391 16.0785C12.593 16.0618 12.593 15.9968 12.6391 15.98L13.1492 15.7961C13.7153 15.5919 14.1613 15.146 14.3655 14.5798L14.5494 14.0697C14.5661 14.0236 14.6316 14.0236 14.6479 14.0697Z"
      fill="#05050C"
    />
  </svg>
)

export const LockedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    style={{ width: 12, height: 12, bottom: 0 }}
  >
    <path
      d="M9.74988 4H9.24988V3C9.24988 1.62 8.12988 0.5 6.74988 0.5C5.36988 0.5 4.24988 1.62 4.24988 3V4H3.74988C3.19988 4 2.74988 4.45 2.74988 5V10C2.74988 10.55 3.19988 11 3.74988 11H9.74988C10.2999 11 10.7499 10.55 10.7499 10V5C10.7499 4.45 10.2999 4 9.74988 4ZM6.74988 8.5C6.19988 8.5 5.74988 8.05 5.74988 7.5C5.74988 6.95 6.19988 6.5 6.74988 6.5C7.29988 6.5 7.74988 6.95 7.74988 7.5C7.74988 8.05 7.29988 8.5 6.74988 8.5ZM8.29988 4H5.19988V3C5.19988 2.145 5.89488 1.45 6.74988 1.45C7.60488 1.45 8.29988 2.145 8.29988 3V4Z"
      fill="#FFC800"
    />
  </svg>
)
